import React, { useRef } from "react";
import { useOutsideClickHandler } from "../../../../Hooks/useOutsideClick";
import Close from "../../../../Assets/Modals/closeIcon.svg";

const ImagePreviewModal = ({ imageUrl, onClose }) => {
  const wrapperRef = useRef(null);

  useOutsideClickHandler(wrapperRef, onClose);

  return (
    <div className="bg-[#00000080] fixed z-50 inset-0 flex justify-center items-center">
      <div
        ref={wrapperRef}
        className="relative bg-white rounded-xl shadow-[0px_0px_12px_0px_#0000003D] p-4 flex flex-col items-center justify-center max-w-[80vw] max-h-[80vh]"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3"
        >
          <img src={Close} alt="Close" />
        </button>

        <img
          src={imageUrl}
          alt="Preview"
          className="max-w-full max-h-[75vh] object-contain rounded-lg"
        />
      </div>
    </div>
  );
};

export default ImagePreviewModal;
